import { render } from "./ShippingServicePreselectionGroupIndex.vue?vue&type=template&id=613964c4"
import script from "./ShippingServicePreselectionGroupIndex.vue?vue&type=script&lang=js"
export * from "./ShippingServicePreselectionGroupIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__